const NOT_FILLED_OPTION = {
  uuid: "notFilled",
  name: "Не заполнено",
  label: "Не заполнено",
};

const SORT_KEYS = {
  name: "lastname,firstname,patronymic",
  table_number: "table_number",
  unit: "unit_name",
  position: "position_name",
  email: "email",
};

export { SORT_KEYS, NOT_FILLED_OPTION };
